export default {"src":"/_next/static/media/truck.04600547.svg","height":15,"width":22};